import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = {
  key: 0,
  class: "card seq-card mb-5 mb-xl-10"
}
const _hoisted_3 = { class: "card-body pt-9 pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_RecentActivityCard = _resolveComponent("RecentActivityCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.pt != 'ovi')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_ECP_EDP_DashboardNavigator)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_RecentActivityCard, { currencySymbol: _ctx.currencySymbol }, null, 8, ["currencySymbol"])
  ]))
}